module.exports = __webpack_public_path__ + "a87aa3a59fb47a2f306b73997af64c6a.ttf";